import { Component, OnInit, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd';
import * as _ from 'lodash';
import { DatePipe } from '@angular/common';
import { disabledStart, disabledEnd } from '../config/constant'
import {
  differenceInCalendarDays, startOfMonth, endOfMonth, startOfISOWeek, endOfISOWeek,
  startOfYear, endOfYear, subDays, startOfDay, endOfDay, getISOWeek, getHours, getMinutes, getSeconds, getISOWeekYear
} from 'date-fns';
import { DisabledTimeFn } from 'ng-zorro-antd/date-picker/standard-types';
// import * as moment from 'moment';
import * as moment_ from 'moment';
const moment = moment_;
@Component({
  selector: 'bcac-noise-search',
  templateUrl: './noise-search.component.html',
  styleUrls: ['./noise-search.component.scss']
})
export class NoiseSearchComponent implements OnInit {
  @Output() bcacSearch = new EventEmitter<any>();

  @Input() bcacDatepickerType: string;
  @Input() bcacQueryDateType: string;
  @Input() bcacDateFormat: string;

  @Input() bcacQueryTimeStart: string | Date; //datepicker
  @Input() bcacQueryTimeEnd: string | Date;     //datepicker

  @Input() bcacQueryTimePickerStart: string | Date;  //小时选择
  @Input() bcacQueryTimePickerEnd: string | Date;//小时选择


  @Input() bcacQueryTime: string | Date; //单个时间框
  @Input() bcacQueryTimePicker: string | Date; //单个时间框time

  @Input() bcacAllDataList: any; //all
  @Input() bcacCheckedAreaList: any; //check
  @Input() bcacCheckedFuncList: any; //check
  @Input() bcacCheckedSiteList: any; //check


  public _isShowAdminArea = true
  @Input() set bcacIsShowAdminArea(show: boolean) {
    this._isShowAdminArea = typeof (show) == "string"
      ? JSON.parse(show)
      : show;
  }

  public _isShowFuncZone = true
  @Input() set bcacIsShowFuncZone(show: boolean) {
    this._isShowFuncZone = typeof (show) == "string"
      ? JSON.parse(show)
      : show;
  }

  public _isShowSite = true
  @Input() set bcacIsShowSite(show: boolean) {
    this._isShowSite = typeof (show) == "string"
      ? JSON.parse(show)
      : show;
  }

  adminAreaList: Array<any> = []; //行政区
  funcZoneList: Array<any> = [];//功能区
  siteList: Array<any> = []; //站点

  selectedAdminAreaList;//选中的行政区
  selectedFuncZoneList
  selectedSiteList

  selectedAreaCode = []
  selectedFuncZone = []
  selectedMn = []

  areaToltalNumber; //总行政区数量
  areaSelectedNumber; //已经选择行政区数量
  mnTotalNumber//所有站点
  mnSelectedNumber
  funcZoneToltalNumber//总功能区
  funcZoneSelectedNumber //已选择功能区

  showmore_area: boolean = false
  showmore_funczone: boolean = false
  showmore_site: boolean = false

  area_allChecked: boolean
  area_indeterminate: boolean
  funczone_allChecked: boolean
  funczone_indeterminate: boolean
  mn_allChecked: boolean
  mn_indeterminate: boolean


  today = new Date();  // 今天
  yesterday = subDays(this.today, 1)


  constructor(
    private message: NzMessageService,
    private datepipe: DatePipe,
  ) { }

  ngOnInit() {
    if (!this._isShowAdminArea && !this._isShowFuncZone && !this._isShowSite) {
      this.queryByTime()
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.bcacAllDataList && this.bcacAllDataList && this.bcacAllDataList.length) {
      let func = []
      let area = []
      let site = []
      for (const item of this.bcacAllDataList) {
        area.push({
          value: item.areaCode,
          label: item.areaName,
          checked: this.bcacCheckedAreaList
            ? this.bcacCheckedAreaList.includes(item.areaCode)
            : true,
          disabled: false
        })
        func.push({
          value: item.funcZone,
          label: item.funcName,
          checked: this.bcacCheckedFuncList
            ? this.bcacCheckedFuncList.includes(item.funcZone)
            : true,
          disabled: false
        })
        site.push({
          value: item.mn,
          label: item.mnName,
          checked: this.bcacCheckedSiteList
            ? this.bcacCheckedSiteList.includes(item.mn)
            : true,
          disabled: false
        })
      }
      this.adminAreaList = this.remove_duplicate(area);
      this.funcZoneList = this.remove_duplicate(func);
      this.siteList = site;

      this.NumberCal('func')
      this.NumberCal('area')
      this.NumberCal('mn')

      this.queryByTime()

      this.adminAreaList = _.sortBy(this.adminAreaList, o => { return o.checked ? 0 : 1 })
      // this.funcZoneList = _.sortBy(this.funcZoneList, o => { return o.checked ? 0 : 1 })
      this.funcZoneList = _.sortBy(_.sortBy(this.funcZoneList, o => { return o.value }), oo => { return oo.checked ? 0 : 1})
      this.siteList = _.sortBy(this.siteList, o => { return o.checked ? 0 : 1 })
    }
    if (changes.bcacCheckedAreaList && this.bcacCheckedAreaList) {
      if (this.adminAreaList && this.adminAreaList.length) {
        this.adminAreaList = this.adminAreaList.map((item) => {
          return {
            ...item,
            checked: this.bcacCheckedAreaList.includes(item.value)
          };
        })
        this.NumberCal('area')
        this.area_allChecked = this.judgeBoxStatus(this.selectedAreaCode, this.adminAreaList).allChecked
        this.area_indeterminate = this.judgeBoxStatus(this.selectedAreaCode, this.adminAreaList).indeterminate
        this.adminAreaList = _.sortBy(this.adminAreaList, o => { return o.checked ? 0 : 1 })
      }
    }
    if (changes.bcacCheckedFuncList && this.bcacCheckedFuncList) {
      if (this.adminAreaList && this.adminAreaList.length) {
        this.funcZoneList = this.funcZoneList.map((item) => {
          return {
            ...item,
            checked: this.bcacCheckedFuncList.includes(item.value)
          };
        })
        this.NumberCal('func')
        this.funczone_allChecked = this.judgeBoxStatus(this.selectedFuncZone, this.funcZoneList).allChecked
        this.funczone_indeterminate = this.judgeBoxStatus(this.selectedFuncZone, this.funcZoneList).indeterminate
        // this.funcZoneList = _.sortBy(this.funcZoneList, o => { return o.checked ? 0 : 1 })
        this.funcZoneList = _.sortBy(_.sortBy(this.funcZoneList, o => { return o.value }), oo => { return oo.checked ? 0 : 1 })
      }
    }
    if (changes.bcacCheckedSiteList && this.bcacCheckedSiteList) {
      if (this.siteList && this.siteList.length) {
        this.siteList = this.siteList.map((item) => {
          return {
            ...item,
            checked: this.bcacCheckedSiteList.includes(item.value)
          };
        })
        this.NumberCal('mn')
        this.mn_allChecked = this.judgeBoxStatus(this.selectedMn, this.siteList).allChecked
        this.mn_indeterminate = this.judgeBoxStatus(this.selectedMn, this.siteList).indeterminate
        this.siteList = _.sortBy(this.siteList, o => { return o.checked ? 0 : 1 })
      }
    }



  }

  //todo 去重
  remove_duplicate(oldlist) {
    let newlist = {};
    return oldlist.reduce((p, c) => {
      newlist[c.value] ? '' : newlist[c.value] = true && p.push(c);
      return p
    }, []);
  }

  //todo 站点数量显示计算
  NumberCal(type) {
    switch (type) {
      case 'mn':
        this.selectedSiteList = this.siteList
        this.selectedMn = this.extractCheckedValue(this.siteList);//选中站点
        this.mnTotalNumber = this.siteList.length
        this.mnSelectedNumber = this.selectedMn.length
        break
      case 'func':
        this.selectedFuncZoneList = this.funcZoneList
        this.selectedFuncZone = this.extractCheckedValue(this.funcZoneList);//选中站点
        this.funcZoneToltalNumber = this.funcZoneList.length  //总功能区
        this.funcZoneSelectedNumber = this.selectedFuncZone.length  //已选择功能区
        break
      case 'area':
        this.selectedAdminAreaList = this.adminAreaList
        this.selectedAreaCode = this.extractCheckedValue(this.adminAreaList);//选中的行政区
        this.areaToltalNumber = this.adminAreaList.length
        this.areaSelectedNumber = this.selectedAreaCode.length
        break
    }
  }

  //todo 数据查询
  queryByTime() {
    let emitpar = {
      startTime: '',
      endTime: '',
      checkedareaCodeList: this._isShowAdminArea ? this.selectedAreaCode : null,
      checkedfuncZoneList: this._isShowFuncZone ? this.selectedFuncZone : null,
      checkedmnList: this._isShowSite ? this.selectedMn : null,
    }
    if (this.bcacDatepickerType == 'double') {
      switch (this.bcacQueryDateType) {
        case 'hour':
          emitpar.startTime = this.datepipe.transform(new Date(this.bcacQueryTimeStart), 'yyyy-MM-dd') + ' ' + this.datepipe.transform(this.bcacQueryTimePickerStart, 'HH:00:00')
          emitpar.endTime = this.datepipe.transform(new Date(this.bcacQueryTimeEnd), 'yyyy-MM-dd') + ' ' + this.datepipe.transform(this.bcacQueryTimePickerEnd, 'HH:59:59')
          break;
        case 'dayshowtime':
          emitpar.startTime = this.datepipe.transform(new Date(this.bcacQueryTimeStart), 'yyyy-MM-dd HH:mm:ss')
          emitpar.endTime = this.datepipe.transform(new Date(this.bcacQueryTimeEnd), 'yyyy-MM-dd HH:mm:ss')
          break;
        case 'daynotshowtime':
          emitpar.startTime = this.datepipe.transform(new Date(this.bcacQueryTimeStart), 'yyyy-MM-dd')
          emitpar.endTime = this.datepipe.transform(new Date(this.bcacQueryTimeEnd), 'yyyy-MM-dd')
          break;
        case 'week':
          emitpar.startTime = this.datepipe.transform(startOfISOWeek(new Date(this.bcacQueryTimeStart)), 'yyyy-MM-dd HH:mm:ss')
          emitpar.endTime = this.datepipe.transform(endOfISOWeek(new Date(this.bcacQueryTimeEnd)), 'yyyy-MM-dd HH:mm:ss')
          break;
        case 'month':
          emitpar.startTime = this.datepipe.transform(startOfMonth(new Date(this.bcacQueryTimeStart)), 'yyyy-MM-dd HH:mm:ss')
          emitpar.endTime = this.datepipe.transform(endOfMonth(new Date(this.bcacQueryTimeEnd)), 'yyyy-MM-dd HH:mm:ss')
          break;
        case 'year':
          emitpar.startTime = this.datepipe.transform(startOfYear(new Date(this.bcacQueryTimeStart)), 'yyyy-MM-dd HH:mm:ss')
          emitpar.endTime = this.datepipe.transform(endOfYear(new Date(this.bcacQueryTimeEnd)), 'yyyy-MM-dd HH:mm:ss')
          break;
      }
    } else {
      switch (this.bcacQueryDateType) {
        case 'hour':
          emitpar.startTime = this.datepipe.transform(new Date(this.bcacQueryTime), 'yyyy-MM-dd') + ' ' + this.datepipe.transform(this.bcacQueryTimePicker, 'HH:00:00')
          emitpar.endTime = this.datepipe.transform(new Date(this.bcacQueryTime), 'yyyy-MM-dd') + ' ' + this.datepipe.transform(this.bcacQueryTimePicker, 'HH:59:59')
          break;
        case 'dayshowtime':
          emitpar.startTime = this.datepipe.transform(startOfDay(new Date(this.bcacQueryTime)), 'yyyy-MM-dd HH:mm:ss')
          emitpar.endTime = this.datepipe.transform(endOfDay(new Date(this.bcacQueryTime)), 'yyyy-MM-dd HH:mm:ss')
          break;
        case 'daynotshowtime':
          emitpar.startTime = this.datepipe.transform(startOfDay(new Date(this.bcacQueryTime)), 'yyyy-MM-dd')
          emitpar.endTime = this.datepipe.transform(endOfDay(new Date(this.bcacQueryTime)), 'yyyy-MM-dd')
          break;
        case 'week':
          emitpar.startTime = this.datepipe.transform(startOfISOWeek(new Date(this.bcacQueryTime)), 'yyyy-MM-dd HH:mm:ss')
          emitpar.endTime = this.datepipe.transform(endOfISOWeek(new Date(this.bcacQueryTime)), 'yyyy-MM-dd HH:mm:ss')
          break;
        case 'month':
          emitpar.startTime = this.datepipe.transform(startOfMonth(new Date(this.bcacQueryTime)), 'yyyy-MM-dd HH:mm:ss')
          emitpar.endTime = this.datepipe.transform(endOfMonth(new Date(this.bcacQueryTime)), 'yyyy-MM-dd HH:mm:ss')
          break;
        case 'year':
          emitpar.startTime = this.datepipe.transform(startOfYear(new Date(this.bcacQueryTime)), 'yyyy-MM-dd HH:mm:ss')
          emitpar.endTime = this.datepipe.transform(endOfYear(new Date(this.bcacQueryTime)), 'yyyy-MM-dd HH:mm:ss')
          break;
      }
    }
    if (new Date(emitpar.startTime).getTime() > new Date(emitpar.endTime).getTime()) {
      this.message.warning("开始时间不能大于结束时间")
      return
    }
    this.bcacSearch.emit(emitpar);
  }


  //todo 提取对象数组的value
  extractCheckedValue(objlist) {
    let selected = []
    for (const item of objlist) {
      if (item.checked) {
        selected.push(item.value)
      }
    }
    return selected
  }

  //todo 提起对象数组label
  extractCheckedLabel(objlist) {
    let selected = []
    for (const item of objlist) {
      if (item.checked) {
        selected.push(item.label)
      }
    }
    return selected
  }

  //todo  行政区全选改变
  area_updateAllChecked(e) {
    this.area_indeterminate = false
    let data
    if (this.area_allChecked) { //全选
      this.areaSelectedNumber = this.adminAreaList.length
      this.adminAreaList = this.adminAreaList.map(item => {
        return {
          ...item,
          checked: true
        };
      });
      data = this.bcacAllDataList.filter((item) => this.selectedFuncZone.includes(item.funcZone))
    } else {
      this.areaSelectedNumber = 0
      this.adminAreaList = this.adminAreaList.map(item => {
        return {
          ...item,
          checked: false
        };
      });
      data = []
    }

    this.siteList = data.map((item) => {
      return {
        value: item.mn,
        label: item.mnName,
        checked: true,
        disabled: false
      }
    })
    this.NumberCal('area')
    this.NumberCal('mn')
    this.mn_allChecked = this.judgeBoxStatus(this.selectedMn, this.siteList).allChecked
    this.mn_indeterminate = this.judgeBoxStatus(this.selectedMn, this.siteList).indeterminate
  }
  //todo 功能区全选改变
  funczone_updateAllChecked(e) {
    this.funczone_indeterminate = false
    let data
    if (this.funczone_allChecked) { //全选
      this.funcZoneSelectedNumber = this.funcZoneList.length
      this.funcZoneList = this.funcZoneList.map(item => {
        return {
          ...item,
          checked: true
        };
      });
      data = this.bcacAllDataList.filter((item) => this.selectedAreaCode.includes(item.areaCode))
    } else {
      this.funcZoneSelectedNumber = 0
      this.funcZoneList = this.funcZoneList.map(item => {
        return {
          ...item,
          checked: false
        };
      });
      data = []
    }
    this.siteList = data.map((item) => {
      return {
        value: item.mn,
        label: item.mnName,
        checked: true,
        disabled: false
      }
    })
    this.NumberCal('func')
    this.NumberCal('mn')
    this.mn_allChecked = this.judgeBoxStatus(this.selectedMn, this.siteList).allChecked
    this.mn_indeterminate = this.judgeBoxStatus(this.selectedMn, this.siteList).indeterminate
  }

  //todo  站点全选改变
  mn_updateAllChecked(e) {
    this.mn_indeterminate = false
    if (this.mn_allChecked) { //全选
      this.mnSelectedNumber = this.siteList.length
      this.siteList = this.siteList.map(item => {
        return {
          ...item,
          checked: true
        };
      });
    } else {
      this.mnSelectedNumber = 0
      this.siteList = this.siteList.map(item => {
        return {
          ...item,
          checked: false
        };
      });
    }
    this.NumberCal('mn')
  }


  //todo 行政区选择改变回调
  adminAreaChangeCallback(e) {
    this.areaSelectedNumber = e.length
    this.selectedAdminAreaList = e
    this.selectedAreaCode = e.map((item) => {
      return item.value
    })
    let data = this.bcacAllDataList.filter((item) => this.selectedAreaCode.includes(item.areaCode) && this.selectedFuncZone.includes(item.funcZone))
    this.siteList = data.map((item) => {
      return {
        value: item.mn,
        label: item.mnName,
        checked: true,
        disabled: false
      }
    })
    this.NumberCal('mn')
    if (e.length && e.length < this.adminAreaList.length) {
      this.area_indeterminate = true
      this.area_allChecked = false
    } else if (e.length == 0) {
      this.area_indeterminate = false
      this.area_allChecked = false
    } else {
      this.area_indeterminate = false
      this.area_allChecked = true
    }
    this.mn_allChecked = this.judgeBoxStatus(this.selectedMn, this.siteList).allChecked
    this.mn_indeterminate = this.judgeBoxStatus(this.selectedMn, this.siteList).indeterminate
  }

  //todo 功能区区选择改变回调
  funcZoneChangeCallBak(e) {
    this.funcZoneSelectedNumber = e.length
    this.selectedFuncZoneList = e
    this.selectedFuncZone = e.map((item) => {
      return item.value
    })

    let data = this.bcacAllDataList.filter((item) => this.selectedAreaCode.includes(item.areaCode) && this.selectedFuncZone.includes(item.funcZone))
    this.siteList = data.map((item) => {
      return {
        value: item.mn,
        label: item.mnName,
        checked: true,
        disabled: false
      }
    })
    this.NumberCal('mn')
    if (e.length && e.length < this.funcZoneList.length) {
      this.funczone_indeterminate = true
      this.funczone_allChecked = false
    } else if (e.length == 0) {
      this.funczone_indeterminate = false
      this.funczone_allChecked = false
    } else {
      this.funczone_indeterminate = false
      this.funczone_allChecked = true
    }
    this.mn_allChecked = this.judgeBoxStatus(this.selectedMn, this.siteList).allChecked
    this.mn_indeterminate = this.judgeBoxStatus(this.selectedMn, this.siteList).indeterminate
  }



  //todo 站点选择改变回调
  querySiteChangeCallback(e) {
    this.mnSelectedNumber = e.length
    this.selectedSiteList = e
    this.selectedMn = e.map((item) => {
      return item.value
    })
    if (e.length && e.length < this.siteList.length) {
      this.mn_indeterminate = true
      this.mn_allChecked = false
    } else if (e.length == 0) {
      this.mn_indeterminate = false
      this.mn_allChecked = false
    } else {
      this.mn_indeterminate = false
      this.mn_allChecked = true
    }
  }

  //todo 展示更多站点
  showMore(type) {
    switch (type) {
      case 'area':
        this.showmore_area = !this.showmore_area
        this.adminAreaList = this.adminAreaList.map(item => {
          return {
            ...item,
            checked: this.selectedAreaCode.includes(item.value) ? true : false
          };
        });
        this.area_allChecked = this.judgeBoxStatus(this.selectedAreaCode, this.adminAreaList).allChecked
        this.area_indeterminate = this.judgeBoxStatus(this.selectedAreaCode, this.adminAreaList).indeterminate
        this.adminAreaList = _.sortBy(this.adminAreaList, o => { return o.checked ? 0 : 1 })
        break;
      case 'funczone':
        this.showmore_funczone = !this.showmore_funczone
        this.funcZoneList = this.funcZoneList.map(item => {
          return {
            ...item,
            checked: this.selectedFuncZone.includes(item.value) ? true : false
          };
        });
        this.funczone_allChecked = this.judgeBoxStatus(this.selectedFuncZone, this.funcZoneList).allChecked
        this.funczone_indeterminate = this.judgeBoxStatus(this.selectedFuncZone, this.funcZoneList).indeterminate
        // this.funcZoneList = _.sortBy(this.funcZoneList, o => { return o.checked ? 0 : 1 })
        this.funcZoneList = _.sortBy(_.sortBy(this.funcZoneList, o => { return o.value }), oo => { return oo.checked ? 0 : 1 })
        break;
      case 'site':
        this.showmore_site = !this.showmore_site
        this.siteList = this.siteList.map(item => {
          return {
            ...item,
            checked: this.selectedMn.includes(item.value) ? true : false
          };
        });
        this.mn_allChecked = this.judgeBoxStatus(this.selectedMn, this.siteList).allChecked
        this.mn_indeterminate = this.judgeBoxStatus(this.selectedMn, this.siteList).indeterminate
        this.siteList = _.sortBy(this.siteList, o => { return o.checked ? 0 : 1 })
        break
    }
  }


  //todo 判断全选状态
  judgeBoxStatus(codelist, objlist) {
    if (codelist.length && codelist.length < objlist.length) {
      return {
        indeterminate: true,
        allChecked: false
      }
    } else if (codelist.length == 0) {
      return {
        indeterminate: false,
        allChecked: false
      }
    } else {
      return {
        indeterminate: false,
        allChecked: true
      }
    }
  }

  range(start: number, end: number): number[] {
    const result: number[] = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  };


  //todo nz-time-picker不可选小时
  nzDisabledHours_start = () => []
  nzDisabledHours_end = () => []
  hourStimeChange() {
    let hours = getHours(new Date)//0~23
    let tod = this.datepipe.transform(new Date(), 'yyyy-MM-dd')
    if (this.datepipe.transform(new Date(this.bcacQueryTimeStart), 'yyyy-MM-dd') == tod) {
      this.nzDisabledHours_start = () => this.range(hours, 24)
    } else {
      this.nzDisabledHours_start = () => []
    }
  }
  hourEtimeChange() {
    let hours = getHours(new Date())//0~23
    let tod = this.datepipe.transform(new Date(), 'yyyy-MM-dd')
    if (this.datepipe.transform(new Date(this.bcacQueryTimeEnd), 'yyyy-MM-dd') == tod) {
      this.nzDisabledHours_end = () => this.range(hours, 24)
    } else {
      this.nzDisabledHours_end = () => []
    }
  }

  //todo日期选择限制
  disabledDate = (current: Date): boolean => {
    return differenceInCalendarDays(current, this.today) > 0;
  }

  //todo 不可选时间 yyyy-MM-dd HH:mm:ss 
  disabledDateTime: DisabledTimeFn = (current: Date) => {
    let curr = this.datepipe.transform(current, 'yyyy-MM-dd')
    let tod = this.datepipe.transform(new Date(), 'yyyy-MM-dd')
    let hours = getHours(new Date())//0~23
    let minutes = getMinutes(new Date())//0~59
    let seconds = getSeconds(new Date());//0~59
    if (curr == tod) {
      return {
        nzDisabledHours: () => this.range(hours + 1, 24),
        nzDisabledMinutes: (hour) => {
          if (hour === hours) {
            return this.range(minutes + 1, 60)
          } else { return [] }
        },
        nzDisabledSeconds: (hour: number, minute: number) => {
          if (hour === hours && minute === minutes) {
            return this.range(seconds + 1, 60)
          } else { return [] }
        }
      };
    }
  };

  //todo 时间选择改变回调
  onStartChange($event) {
    if ($event.getTime() > new Date().getTime()) {
      this.bcacQueryTimeStart = new Date()
    }
  }

  //todo 时间选择改变回调
  onEndChange($event) {
    if ($event.getTime() > new Date().getTime()) {
      this.bcacQueryTimeEnd = new Date()
    }
  }

  //todo 开始不可选分钟
  disabledMinuteStart(hour: number): number[] {
    return disabledStart;
  }

  //todo 结束不可选分钟
  disabledMinuteEnd(hour: number): number[] {
    return disabledEnd
  }

  //todo 开始不可选秒
  disabledSecondsStart(hour: number, minute: number): number[] {
    return disabledStart;
  }

  //todo 结束不可选秒
  disabledSecondsEnd(hour: number, minute: number): number[] {
    return disabledEnd
  }


  //todo 格式化周的显示为ISO
  rewriteWeek(e) {
    // this.bcacDateFormat = getISOWeekYear(e) + '-' + getISOWeek(e)
    this.bcacDateFormat = moment(e).isoWeekYear() + '-' + getISOWeek(e)
  }

  //todo 格式化周的显示为ISO
  bcacDateFormatStart
  rewriteWeekStart(e) {
    this.bcacDateFormatStart = moment(e).isoWeekYear() + '-' + getISOWeek(e)
  }
  //todo 格式化周的显示为ISO
  bcacDateFormatEnd
  rewriteWeekEnd(e) {
    this.bcacDateFormatEnd = moment(e).isoWeekYear() + '-' + getISOWeek(e)
  }


}
